import Hashids from 'hashids'
const hashids = new Hashids();

export const loadIntoHash = (idArray) => {
  const hashedArray = hashids.encode(idArray)
  window.location.hash = `${hashedArray}`;
}

export const clearHash = () => {
  const noHashURL = window.location.href.replace(/#.*$/, '');
  window.history.replaceState('', document.title, noHashURL)
}

export const clearQueryString = () => {
  const noQueryURL = window.location.href.replace(/\?.+/, '');
  window.location.href = noQueryURL
}

export const retrieveFromHash = () => {
  const hashstring = window.location.hash
  const Hash = hashstring.replace('#', '');
  const decodedHash = hashids.decode(Hash);
  return decodedHash.filter(e => e).map(e => `${e}`);
}



// WEBPACK FOOTER //
// ./src/common/helper.js